"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Constants_1 = require("@src/app/commons/Constants");
const DEBUG_1 = require("@src/DEBUG");
DEBUG_1.DEBUG.open('/xs/controllers/defaults');
const base_class_1 = require("../controllers/base.class");
// const Hash = require('object-hash');
/*
  XsDefaults reads in data / properties from items, and flags whether we've collected those defaults or not
*/
class XsDefaults extends base_class_1.XsBaseClass {
    constructor(config = {}) {
        super(config);
        this.debugId = 'DEFAULTS';
        this.store = {};
        if (this.debug) {
            console.log(this.debugId + ' :: CONSTRUCTOR');
        }
        DEBUG_1.DEBUG.log('/xs/controllers/defaults');
        if (this._config) {
            this.init();
        }
    }
    init() {
        if (this._config['items']) {
            this._config['items'].forEach(item => {
                this.store[item] = {
                    value: null, fetched: false
                };
            });
        }
        if (this.debug) {
            console.log('%c ** init()', Constants_1.Constants._pink, this.store);
        }
    }
    readFromItem(item = null) {
        if (item && item['__saved_defaults']) {
            Object.keys(item['__saved_defaults']).forEach(key => {
                if (this.store[key]) {
                    this.store[key].value = JSON.parse(item['__saved_defaults'][key]);
                }
            });
        }
        if (this.debug) {
            console.log('%c ** readFromItem()', Constants_1.Constants._pink, item, this.store);
        }
    }
    writeToItem(item = null) {
        if (item) {
            if (!item['__saved_defaults']) {
                item['__saved_defaults'] = {};
            }
            Object.keys(this.store).forEach(key => {
                if (this.store[key] && this.store[key].value) {
                    item['__saved_defaults'][key] = JSON.stringify(this.store[key].value);
                }
            });
        }
        if (this.debug) {
            console.log('%c ** writeToItem()', Constants_1.Constants._pink, item, this.store);
        }
    }
    put(key = null, data = null) {
        if (this.debug) {
            console.log('%c ** put()', Constants_1.Constants._pink, key);
        }
        if (this.store[key]) {
            this.store[key].value = data;
            this.store[key].fetched = true; // putting data in dirties the cache, so no need to fetch it
        }
        return null;
    }
    fetch(key = null, forced = false) {
        if (this.debug) {
            console.log('%c ** fetch()', Constants_1.Constants._pink, key);
        }
        if (this.store[key] && (!this.store[key].fetched || forced)) {
            this.store[key].fetched = true;
            return this.store[key].value;
        }
        return null;
    }
    isFetched(key = null) {
        if (this.store[key]) {
            return this.store[key].fetched;
        }
        return false;
    }
    hasValue(key = null) {
        if (this.store[key] && this.store[key].value) {
            return true;
        }
        return false;
    }
}
exports.XsDefaults = XsDefaults;
